<template lang="pug">
  .lottier-container(v-if="url" ref="lottie" v-bind="$attrs")
</template>

<script>
import lottie from 'lottie-web';

export default {
  props: {
    url: {
      type: String,
      default: null,
    },
    loop: {
      type: Boolean,
      default: true,
      required: false,
    },
    autoplay: {
      type: Boolean,
      default: true,
      required: false,
    },
  },
  data() {
    return {
      id: Math.random(),
      instance: null,
    };
  },
  computed: {
    lottie() {
      return this.instance;
    },
  },
  mounted() {
    if (!this.url) {
      return;
    }
    if (this.$refs.lottie) {
      this.instance = lottie.loadAnimation({
        container: this.$refs.lottie,
        renderer: 'svg',
        loop: this.loop,
        autoplay: this.autoplay,
        name: this.name,
        path: this.url,
      });
    }
  },
  destroyed() {
    if (this.$refs.lottie) {
      lottie.destroy(this.name);
    }
  },
  methods: {

  },
};
</script>

<style lang="less" scoped>
.lottier-container {
  display: flex;
  position: relative;
  overflow: hidden;
}
</style>
